import React from "react";

function UnsavedChangesGuard({ t, onSave, onDiscard, onKeepEditing }) {
  return (
    <div className="unsaved-overlay">
      <div className="unsaved-dialog">
        <p className="unsaved-msg">{t.common.unsavedChanges}</p>
        <div className="unsaved-actions">
          <button className="btn-ghost" onClick={onKeepEditing}>{t.common.unsavedKeepEditing}</button>
          <button className="btn btn-secondary" onClick={onDiscard}>{t.common.unsavedDiscard}</button>
          <button className="btn btn-primary" onClick={onSave}>{t.common.unsavedSave}</button>
        </div>
      </div>
    </div>
  );
}

export default UnsavedChangesGuard;
